// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner-full-page-module__wrapper___X7_Fh"};